import React, { ChangeEventHandler } from 'react';
import cn from 'classnames';
import './Radio.scss';

interface RadioProps {
    onChange: ChangeEventHandler;
    value: string;
    label: string | React.ReactNode;
    selectedValue: string;
    disabled?: boolean;
}

function Radio({ onChange, value, label, selectedValue, disabled }: RadioProps) {
    return (
        <div
            className={cn('Radio', {
                'Radio--disabled': disabled,
            })}
        >
            <input
                id={`Radio_${value}`}
                value={value}
                type="radio"
                checked={selectedValue === value}
                onChange={onChange}
                disabled={disabled}
            />
            <label htmlFor={`Radio_${value}`} className="Radio__label">
                {label}
            </label>
        </div>
    );
}

export default Radio;
